import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4165ae9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-1/1 h-1/1" }
const _hoisted_2 = { class: "main border border-gray-400" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top_title text-xl text-white" }, "设置新密码", -1))
const _hoisted_4 = { class: "form_content" }
const _hoisted_5 = { class: "login" }
const _hoisted_6 = { class: "flex justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_form, {
          model: _ctx.formState,
          rules: _ctx.rules,
          ref: "formRef",
          name: "basic",
          onFinish: _ctx.onFinish,
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { name: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.formState.password,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.password) = $event)),
                  type: "password",
                  placeholder: "输入新密码",
                  maxlength: 11
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { name: "surePassword" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.formState.surePassword,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.surePassword) = $event)),
                  type: "password",
                  placeholder: "再次输入新密码"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      ghost: "",
                      onClick: _ctx.cancle
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("取消")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      "html-type": "submit"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("确定")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules", "onFinish"])
      ])
    ])
  ]))
}